<div class="modal-header">
    <h1>Crop image</h1>
</div>
<div class="modal-body">
    <img #image class="modal__image" alt="crop image">
</div>
<div class="modal-footer">
    <button class="btn btn-default" (click)="onDeclineClick()">Decline</button>
    <button class="btn btn-success" (click)="crop()">Accept</button>
</div>
